import * as React from 'react';
import SearchCondition from "./components/SearchCondition";
import {useEffect, useState} from "react";
import {MailTemplateSearchCondition} from "../../../../modules/mail/dto/MailTemplateSearchCondition";
import {MailTemplateDto} from "../../../../modules/mail/dto/MailTemplateDto";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import {MailTemplateApi} from "../../../../modules/mail/api/MailTemplateApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {useIntl} from "react-intl";
import SearchResult from "./components/SearchResult";
import DetailDialog from "./components/DetailDialog";
import PaginationBar from "../../../../components/PaginationBar";
import {Paper} from "@mui/material";

export default function Index() {
    const intl = useIntl();

    useEffect(() => {
        handleSearch(searchCondition);
    }, []);

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new MailTemplateSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<MailTemplateDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const [openDetailDialog, setOpenDetailDialog] = useState(false);

    const [currentRow, setCurrentRow] = useState<MailTemplateDto>(new MailTemplateDto());

    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const handleSearch = async (searchCondition: MailTemplateSearchCondition) => {
        const responseResult = await MailTemplateApi.queryMailTemplates(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const handleClickModify = async (record: MailTemplateDto) => {
        const responseResult = await MailTemplateApi.getMailTemplateDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailDialog(true);
        }
    };

    const handleClickDelete = async (record: MailTemplateDto) => {
        const responseResult = await MailTemplateApi.deleteMailTemplate(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
            handleSearch(searchCondition);
        }
    };

    const handleClickAdd = () => {
        setCurrentRow(new MailTemplateDto());
        setOpenDetailDialog(true);
    };

    const handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        handleSearch(newSearchCondition);
    };

    return (
        <div>
            <DetailDialog open={openDetailDialog} mailTemplate={currentRow}
                          onClose={() => setOpenDetailDialog(false)} onOk={() => handleSearch(searchCondition)}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={handleChangeCondition}
                                 onClickSearch={() => handleSearch(searchCondition)}
                                 onClickAdd={handleClickAdd}/>
            </Paper>
            <br/>

            <Paper sx={{p: 1}}>
                <PaginationBar pagination={pagination} onChange={handlePagination}/>
                <br/>
                <SearchResult searchResult={searchResult}
                              onClickDelete={(record) => handleClickDelete(record)}
                              onClickModify={(record) => handleClickModify(record)}/>
            </Paper>
        </div>
    );
}